import { useEffect, useRef, useState } from 'react';
import { Box, useTheme } from '@mui/material';
import PromoPhone from '../../assets/images/frame-mockup-iphone-desktop.webp';

const ParallaxPhoneWeb = ({ sx }) => {
  const phoneRef = useRef(null);
  const containerRef = useRef(null);
  const [offset, setOffset] = useState(0);
  const lastScrollY = useRef(0);

  useEffect(() => {
    const handleScroll = () => {
      if (!containerRef.current || !phoneRef.current) return;

      const containerRect = containerRef.current.getBoundingClientRect();
      const imageRect = phoneRef.current.getBoundingClientRect();
      const imageHeight = imageRect.height;
      const containerHeight = containerRef.current.offsetHeight;
      const windowHeight = window.innerHeight;

      const triggerOffset = 70;
      const maxOffset = containerHeight - imageHeight;
      const currentScrollY = window.scrollY;
      const scrollingDown = currentScrollY > lastScrollY.current;
      const releaseScrollThreshold = windowHeight - 70;

      lastScrollY.current = currentScrollY;

      // 1. Scroll subindo — fica colado no bottom da viewport
      if (
        !scrollingDown &&
        containerRect.bottom > imageHeight &&
        containerRect.top < triggerOffset &&
        imageRect.bottom > windowHeight - 70 // ✅ enquanto ainda não passou do limite
      ) {
        const offsetFromBottom =
          window.scrollY +
          windowHeight -
          containerRef.current.getBoundingClientRect().top -
          imageHeight;

        const clamped = Math.min(Math.max(offsetFromBottom, 0), maxOffset);
        setOffset(clamped);
      }

      // 2. Scroll subindo — já passou o limite, então começa a subir normalmente
      else if (
        !scrollingDown &&
        containerRect.bottom > imageHeight &&
        imageRect.bottom <= windowHeight - 70 // ✅ nova condição de liberação
      ) {
        const clampedScroll = Math.min(
          Math.max(triggerOffset - containerRect.top, 0),
          maxOffset
        );
        setOffset(clampedScroll);
      }

      // 3. Scroll descendo — segue normalmente
      else if (
        scrollingDown &&
        containerRect.top <= triggerOffset &&
        containerRect.bottom > imageHeight
      ) {
        const clampedScroll = Math.min(
          Math.max(triggerOffset - containerRect.top, 0),
          maxOffset
        );
        setOffset(clampedScroll);
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <Box
      ref={containerRef}
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
        position: 'relative',
        height: '100%',
        width: '100%',
        minWidth: { xs: '100%', md: 'auto' },
        overflow: { xs: 'hidden', md: 'visible' },
        ...sx,
      }}
    >
      <Box
        ref={phoneRef}
        component="img"
        src={PromoPhone}
        alt="A promotional phone mockup"
        loading="lazy"
        sx={{
          position: 'absolute',
          top: 0,
          right: 0,
          width: '112%',
          height: 'auto',
          zIndex: { xs: 1, md: 'auto' },
          transition: 'transform 0.5s cubic-bezier(0.25, 0.1, 0.25, 1)',
          willChange: 'transform',
          transform: `translateY(${offset}px)`,
        }}
      />
    </Box>
  );
};

export default ParallaxPhoneWeb;
